import { NavigationItem } from "@/types";

/**
 * Menu configuration for the application
 * Labels are translation keys (e.g., "navigation.palConfiguration")
 */

export const MAIN_MENU_ITEMS: readonly NavigationItem[] = [
  {
    id: "pal-configuration",
    label: "navigation.palConfiguration",
    path: "/pal-configuration",
  },
] as const;

/**
 * Administration menu items - requires CC_ADMIN role
 * This is a parent menu with submenus
 */
export const ADMIN_MENU_ITEMS: readonly NavigationItem[] = [
  {
    id: "administration",
    label: "navigation.administration",
    requiredRole: "CC_ADMIN",
    children: [
      {
        id: "data-source-attribute-registration",
        label: "navigation.dataSourceAttributeRegistration",
        path: "/administration/data-source-registration",
        requiredRole: "CC_ADMIN",
      },
    ],
  },
] as const;

export const SUBMENU_ITEMS: readonly NavigationItem[] = [] as const;

export const FOOTER_MENU_ITEMS: readonly NavigationItem[] = [] as const;

export const MENU_ITEM_IDS = {
  PAL_CONFIGURATION: "pal-configuration",
  ADMINISTRATION: "administration",
  DATA_SOURCE_ATTRIBUTE_REGISTRATION: "data-source-attribute-registration",
} as const;
